const _message = function(parentError) {
    if (parentError) {
        return parentError.message
    }

    return 'no message'
}

class WriterError extends Error {
    constructor(code, parentError, errorParams) {

        super()

        this.code = code
        this.parameters = errorParams
        this.parentError = parentError
        this.stack = (new Error()).stack
        this.errorId = new Date().getTime()

        this.message = `(${this.errorId})  ${_message(parentError)}(${code}) [${JSON.stringify(errorParams)}]`

    }
}

export {WriterError}
